import FormField from "../form-field";

export default class AgreementField extends FormField {
	constructor(props) {
		super(props);

		this.sendable = false;
		this.required = true;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('AgreementField: Root element is not defined!');
		}

		this.$input = this.$root.querySelector('.checkbox_input');

		if (!this.$input) {
			throw new Error('AgreementField: Input element is not defined!');
		}

		super.init();
	}

	addEventListeners() {
		this.$input.addEventListener('change', this.handleChange.bind(this));
	}

	handleChange(e) {
		this.setValue(e.target.checked);
		this.validateStrict();
	}

	validate() {
		this.isValid = this.value;
	}

	setInitialState() {
		this.$input.checked = false;
		this.$input.dispatchEvent(new Event('change'));
	}
}